/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.assetLibraryModule').controller('AssetLibraryController', ['$scope','BulbAssetLibraryService','BulbAuthService', AssetLibraryController]);

function AssetLibraryController($scope, BulbAssetLibraryService, BulbAuthService) {
  $scope.assetLibraryService = BulbAssetLibraryService;
  $scope.currentUser = BulbAuthService.currentUser;
}


